export interface TransactionInterface {

}

export enum TransactionStatuses {
  PENDING = 1,
  PAID = 2,
  REFUNDED = 3
}

// Mirrors sporapi InvoiceStatusesEnum. A paid post is awaiting the admin's
// accept/reject decision while its invoice is PROFORMA; once accepted the
// invoice becomes FISCAL, once rejected it is DELETED.
export enum InvoiceStatuses {
  PROFORMA = 1,
  FISCAL = 2,
  DELETED = 3,
  CANCELED = 4
}